import React from 'react';
import { map } from 'lodash';

export const Observations = () => {
  const observations = [
    '• Os dados informados neste anúncio são de inteira responsabilidade do anunciante. Cabe ao comprador certificar-se da veracidade das informações e estado de conservação do veículo.',
    '• A Autoscar não realiza nenhum tipo de intermediação no processo de vendas, compras e trocas negociadas neste portal e não se responsabiliza por quaisquer danos causados ao usuários em decorrência de algum desacordo do anúncio com as leis criminais, cíveis ou de consumo.',
    '• Ressalta-se que a Autoscar atua apenas como meio de veiculação para compra e venda de carros, motos, triciclos, caminhões, vans, ônibus e outros veículos, além de serviços automotivos em geral.',
  ];
  const observationItems = map(observations, (observation: string) => (
    <li key={observation} className="mb12">
      {observation}
    </li>
  ));
  return (
    <section className="ma0 f11 fw4 pa0 mt40 mt48-ns pb48 pb72-l mb8 mb0-l">
      <h4 className="ma0 f11 fw4 abbey">Atenção</h4>
      <ul className="pa0 ma0 abbey f11 fw4 lh-copy list">{observationItems}</ul>
    </section>
  );
};
